import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createElementVNode as _createElementVNode, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3cb90acf"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "nav__header"
}
const _hoisted_2 = { class: "nav__group" }
const _hoisted_3 = { class: "nav__group" }
const _hoisted_4 = { class: "menu-toggle" }
const _hoisted_5 = ["checked"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "lines" }, null, -1))
const _hoisted_7 = { class: "fold-out-menu" }
const _hoisted_8 = { class: "fold-out-menu__links" }
const _hoisted_9 = ["title"]

import { computed, onMounted, ref, watch } from 'vue'
import type { Ref } from 'vue'
import { User } from '@/api/authApi/types'
import { vehiclesApi } from '@/api/vehiclesApi'
import { Vehicle } from '@/api/vehiclesApi/types'
import { t } from '@/i18n'
import { useRouter, useRoute } from 'vue-router'
import authStore from '@/store/auth'
import userStore from '@/store/user'


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    currentUser: {}
  },
  setup(__props: any) {

const router = useRouter()
const route = useRoute()
const props = __props

const { currentVehicleUuid, setCurrentVehicleUuid } = userStore
const currentVehicle: Ref<Vehicle | null> = ref(null)
const isMenuOpen = ref<boolean>(false)

const hasChosenVehicle = computed(() => !!currentVehicleUuid.value)

const logoutUser = async () => {
  isMenuOpen.value = false
  await authStore.logoutUser()
  await router.push('/login')
}

watch(
  () => currentVehicleUuid.value,
  async vehicleUuid => {
    if (vehicleUuid) {
      currentVehicle.value = await vehiclesApi.get(vehicleUuid)
      if (currentVehicle.value) setCurrentVehicleUuid(currentVehicle.value.uuid)
    }
  },
)

onMounted(async () => {
  if (currentVehicleUuid.value) {
    currentVehicle.value = await vehiclesApi.get(currentVehicleUuid.value)
    if (currentVehicle.value) setCurrentVehicleUuid(currentVehicle.value.uuid)
  }
})

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (props.currentUser)
    ? (_openBlock(), _createElementBlock("header", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (_unref(route).name === 'Action')
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "back_button",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).push({ name: 'AssignedOrders' })))
              }, _toDisplayString(_unref(t)(`nav.${_unref(route).params.name}`)), 1))
            : (hasChosenVehicle.value)
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 1,
                  to: "/",
                  title: `${_unref(t)('assignedOrders.title')} ${currentVehicle.value?.name}`
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('assignedOrders.title')) + " " + _toDisplayString(currentVehicle.value?.name), 1)
                  ]),
                  _: 1
                }, 8, ["title"]))
              : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("input", {
              type: "checkbox",
              checked: isMenuOpen.value,
              onClick: _cache[1] || (_cache[1] = ($event: any) => (isMenuOpen.value = !isMenuOpen.value))
            }, null, 8, _hoisted_5),
            _hoisted_6,
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_router_link, {
                class: "fold-out-menu__user",
                to: "/info",
                title: _unref(t)('info.loginDetails'),
                onClick: _cache[2] || (_cache[2] = ($event: any) => (isMenuOpen.value = false))
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", null, _toDisplayString(props.currentUser?.first_name) + " " + _toDisplayString(props.currentUser?.last_name), 1),
                  _createTextVNode(" " + _toDisplayString(props.currentUser?.email), 1)
                ]),
                _: 1
              }, 8, ["title"]),
              _createElementVNode("ul", _hoisted_8, [
                _createElementVNode("li", null, [
                  _createVNode(_component_router_link, {
                    to: "/vehicles/selection",
                    title: _unref(t)('vehicleSelection.changeVehicle'),
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (isMenuOpen.value = false))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)('vehicleSelection.changeVehicle')), 1)
                    ]),
                    _: 1
                  }, 8, ["title"])
                ]),
                _createElementVNode("li", null, [
                  _createVNode(_component_router_link, {
                    to: "/info",
                    title: _unref(t)('info.changeLocale'),
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (isMenuOpen.value = false))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)('info.changeLocale')), 1)
                    ]),
                    _: 1
                  }, 8, ["title"])
                ]),
                _createElementVNode("li", null, [
                  _createElementVNode("button", {
                    title: _unref(t)('meta.logout'),
                    onClick: logoutUser
                  }, _toDisplayString(_unref(t)('meta.logout')), 9, _hoisted_9)
                ])
              ])
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})